import React from 'react'
import { Box } from '@mui/material';
import AppPage from '@/ui/AppPage/AppPage';
import Permissions from '@/lib/permissions';
import DynamicFormsTable from './DynamicFormsTable';

const DynamicFormsPage = () => (
    <AppPage
      titlett="admin:page.dynamic_forms"
      needPermission={[Permissions.Administration]}
    >
      <Box m={0} style={{ height: '100%' }}>
        <DynamicFormsTable />
      </Box>
    </AppPage>
  )

export default DynamicFormsPage;